import authProvider from "../config/authProvider"
import { safeLocalStorage } from '../utils/safeLocalStorage';

function decodeJwtPayload(token: string): { exp: number; [key: string]: unknown } | null {
    const parts = token.split('.');
    if (parts.length < 2 || !parts[1]) {
        return null;
    }
    let base64 = parts[1];
    // Handle URL-safe base64 characters used in JWTs
    base64 = base64.replace(/-/g, '+').replace(/_/g, '/');
    // Pad to a multiple of 4
    while (base64.length % 4 !== 0) {
        base64 += '=';
    }
    try {
        return JSON.parse(atob(base64));
    } catch {
        return null;
    }
}

export async function getToken(): Promise<string> {
    const token = safeLocalStorage.get("token") || "";
    const decode = decodeJwtPayload(token);
    if (!decode || decode.exp * 1000 < new Date().getTime()) {
        try {
            let authResult = await authProvider.handleRedirectPromise();
            let accountObj;
            if (authResult) {
                safeLocalStorage.set("token", authResult.accessToken);
                accountObj = authResult.account;
            } else {
                accountObj = authProvider.getAllAccounts()[0];
            }
            if (accountObj && authResult) { }
            else if (accountObj) {
                try {
                    authResult = await authProvider.acquireTokenSilent({
                        account: authProvider.getAllAccounts()[0],
                        scopes: ["user.read"]
                    })
                } catch (err) {
                    await authProvider.acquireTokenRedirect({ scopes: ["user.read"] });
                }
            }
            else {
                await authProvider.loginRedirect({ scopes: ["user.read"] })
            }
            if (authResult && authResult.accessToken) {
                safeLocalStorage.set("token", authResult.accessToken);
            }
            return authResult?.accessToken || "";
        } catch (err) {
            console.error(err)
            return "";
        }
    } else {
        return token;
    }
}